import React from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { useEntityNavigate as useNavigate } from '../../navigation/navigation'
import EntityForm from '../../components/EntityForm'
import EntityHistory from '../../components/EntityHistory'
import { Button } from '../../components/ui'
import './Company.css'

function ContactEdit() {
  const { clientId, id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const isNew = location.pathname.endsWith('/new') || id === 'new'
  const editId = isNew ? null : id

  return (
    <div className="company-page">
      <div className="page-header">
        <Button variant="ghost" onClick={() => navigate(`/client/${clientId}`)} className="btn-back">
          ← Назад к клиенту
        </Button>
      </div>
      <EntityForm
        entityType="contacts"
        entityId={editId}
        context={{ clientId }}
        title={isNew ? 'Новый контакт' : 'Редактирование контакта'}
      />
      {editId && <EntityHistory entityType="contacts" entityId={editId} />}
    </div>
  )
}

export default ContactEdit
